import { render } from "./App.vue?vue&type=template&id=3ef29628"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ddc-vas-production-fe-gcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__